const apiBase = `${process.env.REACT_APP_API_URI}`;

export const frameApiUrl = (
  path: string,
  query?: { [key: string]: any } | undefined
) => {
  const url = new URL(`${apiBase}${path}`, window.location.origin);

  if (query != null) {
    for (const [key, value] of Object.entries(query)) {
      if (value == null) {
        delete query[key];
      }
    }

    const searchParams = new URLSearchParams(query);
    url.search = searchParams.toString();
  }

  return url;
};
